/* eslint-disable no-param-reassign */
/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017-2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.coverImageModule')
  .service('BulbCoverImageService', ['$translate', 'BulbAssetLibraryService', 'BulbModalService', BulbCoverImageService]);

/**
 * Handles cover images on collections, groups, pages and author units. Gives extra options and allows the user to
 * select blurry images.
 */
function BulbCoverImageService($translate, BulbAssetLibraryService, BulbModalService) {

  /*
   * This function is used for all cover images on the site, and determines whether or not the place it is coming from
   * is a compositeView or a pageView, to handle the image appropriately.
   */
  this.calculateCoverImageSize = function calculateCoverImageSize(entry, setting, that, fromCtrl) {
    return $translate('cover_image_too_small_label', { width: setting.minWidth, height: setting.minHeight }).then(
      (message) => {
        const modalOptions = {
          templateUrl: 'ajs/components/coverimage/coverimage.html',
          showCancelButton: false,
          showOkButton: false,
          titleText: false,
          windowClass: 'bulb-cover-image-options-modal',
          controller: ['$scope', function coverImgModalCtrl($scope) {
            $scope.coverImageBodyTemplate = message;
          }],
        };

        BulbModalService.show(modalOptions).then(() => {
          // This callback will occur if they choose to continue on using the blurry version of the photo,
          // and not pick a new one to use.

          const sharedAsset = {
            id: entry.image.id,
            assetDefinitionsKey: 'coverImage',
            url: entry.image.url,
            width: entry.image.width,
            height: entry.image.height,
          };

          BulbAssetLibraryService.dialog.dismissAllModals();

          if (fromCtrl === 'pageView') {
            that.coverImageMode = 'editor';
            that.isCoverImageUploadActive = false;

            that.coverImageEdit = {
              isNew: !that.page.unit.coverImage,
              asset: sharedAsset,
              cropType: 'CROP_COVER_IMAGE',
            };
          } else if (fromCtrl === 'compositeView') {
            that.mode = 'editor';
            that.isCoverImageUploadActive = false;
            that.edit = {
              isNew: !that.compositeUnit.coverImage,
              asset: sharedAsset,
              cropType: 'CROP_COVER_IMAGE',
            };
          }
        });
      },
    );
  };
}
